import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zipcode'
})
export class ZipcodePipe implements PipeTransform {
    transform(zip : string) {
        if (!zip) return '';

        if (zip.length > 5) {
            let zip1 = zip.substr(0, 5);
            let zip2 = zip.substr(5);

            if (zip2 !== '0000') {
                return `${zip1}-${zip2}`;
            } else {
                return zip1;
            }
        } else return zip;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/zipcode.pipe.ts